import axios from 'axios'

import store from '../store'
import { showGlobalError } from '../store/actions'
import { storage } from '../utils'

import envConfig from './envConfig'

const env: string = process.env.NODE_ENV === 'none' ? 'staging' : process.env.NODE_ENV ?? 'production'

const b3request = axios.create({
  baseURL: envConfig[env].baseUrl,
  timeout: 1000 * 10 * 60 * 5,
})

b3request.interceptors.request.use(config => {
  config.headers = {
    ...config.headers,
    authToken: storage.B3B2BToken.getValue(),
  }
  if (config.params && config.params.orderBy) {
    config.params = {
      ...config.params,
    }
  }

  return config
})

b3request.interceptors.response.use(resp => {
  const {
    code,
    message,
    data,
    detail
  } = resp.data

  if (resp.status !== 200) {
    store.dispatch(showGlobalError(new Error(resp.statusText)))
  }

  switch (code) {
    case 200: break
    case 10015: return Promise.reject()
    default: {
      store.dispatch(showGlobalError(new Error(message || detail)))
      return Promise.reject()
    }
  }

  return data
})

export default b3request
